import { animate, state, style, transition, trigger } from '@angular/animations';
import { DOCUMENT, isPlatformServer } from '@angular/common';
import { Component, HostListener, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { MktEnvironmentService } from 'src/app/core/services/mkt-environment.service';

@Component({
	selector: 'app-credit-card-conversion-header',
	templateUrl: './credit-card-conversion-header.component.html',
	styleUrls: ['./credit-card-conversion-header.component.scss'],
	standalone: false,
	animations: [
		trigger('toggleMenuButton', [
			state('true', style({ right: "268px", "background-position": "100%" })),
			state('false', style({ right: "0px", "background-position": "100%" })),
			transition('true => false', animate("400ms")),
			transition('false => true', animate("400ms"))
		]
		),
		trigger('menuItems', [
			state('true', style({ right: "0px", "background-position": "100%" })),
			state('false', style({ right: "-268px", "background-position": "100%" })),
			transition('true => false', animate("400ms")),
			transition('false => true', animate("400ms"))
		]
		)
	],
})
export class CreditCardConversionHeaderComponent implements OnInit {
	toggleMenu: boolean = false;
	animationToggleMenu = 'false';
	@Input() logoLink: string = 'javascript:void(0);';
	@Input() logoImage: any;
	@Input() headerLinks: any;
	@Input() footerLinks: any;
	public imagePrefix: string;
	public selectedMenu = 0;
	constructor(@Inject(DOCUMENT) private _document: Document,
		@Inject(PLATFORM_ID) private plateform_id,
		private mktEnvironmentService: MktEnvironmentService) {
		this.imagePrefix = this.mktEnvironmentService.getEnvironmentVar('cardsmkrHostName');
	}

	ngOnInit() {
		this.menuHandle();
	}

	@HostListener("window:resize", ["$event"])
	menuHandle() {
		if (isPlatformServer(this.plateform_id)) return;
		this.toggleMenu = window.innerWidth > 768 ? true : false;
		this.showSideNavigation();
	}

	showSideNavigation() {
		this.animationToggleMenu = this.toggleMenu ? 'true' : 'false';
		if (this.toggleMenu) {
			this._document.querySelector('.inlineNavContainer').setAttribute("style", "display:flex;");
			this._document.querySelector('.inlineNavContainer .headerContainer').setAttribute("style", "display:flex;");
			this._document.querySelector('.headerContainer ul').setAttribute("style", "display:flex;");

		}
		else {
			this._document.querySelector('.inlineNavContainer').setAttribute("style", "display:none;");
			this._document.querySelector('.inlineNavContainer .headerContainer').setAttribute("style", "display:none;");
			this._document.querySelector('.headerContainer ul').setAttribute("style", "display:none;");
		}
	}

	scrollToElement($element, index) {
		this.selectedMenu = index;
		let element = this._document.getElementById($element);
		element.scrollIntoView(
			{
				behavior: "smooth",
				block: "start",
				inline: "center"
			}
		);
		this.menuHandle();
	}
}
